export * from './slider';
export * from './slider.props';
